export default __webpack_public_path__ + "static/media/kostyambl-ph.9b1ad34e.webp";